import Vue from 'vue'
// import mixpanel from 'mixpanel-browser';
// import 'default-passive-events'
import './third-party/zendesk'
import router from '@/router-v2'
import store from '@/store'
import checkPermission from '@/utils/permission'
import * as filters from '@/filters'
import bulletinNotify from '@/components/bulletin-notify/index'
import SvgIcon from "@/components/svg-icon"
import App from './App.vue'
import '@/router-v2/permission'
import '@/utils/vueWorker'
import '@/utils/element-ui'
import '@/utils/view-img'
import '@/utils/ui-v2'
import '@/components-v3'
import '@/utils/view-img'
import '@/fleet-element'
import '@/style/index.scss'
import '@/utils/beforeunload'
import buriedPoints from '@/utils/buriedPoint'
import zendeskShow from '@/utils/zendesk'
import '@/utils/header-fixed'
import moment from 'moment-timezone'
import singleSpaVue from "single-spa-vue"
import { sliceNumber, toNumber } from "@/utils/number";
import {DSPNotification$, globalImport, spaService$, systemInfo} from "@/shared-services";
import { initApiWorker } from "@/views/map/components/map/tools/weather";
import VueClipboard from 'vue-clipboard2';
if (systemInfo.isCommand) {
  initApiWorker();
}
moment.tz.load(require('./json/time-zone.json'));
Vue.use(VueClipboard);
// auth();
// mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKNE);
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(bulletinNotify.register)
Vue.component('SvgIcon', SvgIcon)
Vue.config.productionTip = false
Vue.prototype.$tpNotification = (options) => DSPNotification$.subscribe(x => x('message', options))
Vue.prototype.$checkPermission = checkPermission
// Vue.prototype.$mixpanel = mixpanel
Vue.prototype.$buriedPoints = buriedPoints
Vue.prototype.$zendeskShow = zendeskShow
Vue.prototype.$store = store
// 定义全局点击函数
Vue.prototype.globalClick = function (callback) {
  document.getElementById("root").onclick = function ($event) {
    if (callback) callback($event);
  };
};
Vue.mixin({
  methods: {
    sliceNumber,
    toNumber
  }
})

document.body.onkeyup = $event => {
  if ($event.key !== 'Enter') {
    return
  }
  const el = document.getElementById('Enter')
  if(el) {
    el.click()
  }
}

const vueOptions = {
  el: "#app",
  router,
  store,
  render: h => h(App),
}
// if (process.env.STANDALONE_SINGLE_SPA === 'true') {
//   delete vueOptions.el;
//   const main = new Vue(vueOptions).$mount('#app');
// }

const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: vueOptions
});
export const bootstrap = vueLifecycles.bootstrap;
export const mount = vueLifecycles.mount
export const unmount = vueLifecycles.unmount;
export default vueLifecycles;

if (systemInfo.isCommand) {
  spaService$.subscribe(x => {
    x.registerDispatch()
  })
}

setTimeout(() => {
  globalImport.importAll()
}, 3000)

